export const canLoadDeliveryAreasSellarDistribution = ({
  enabled = true,
  supplierId,
  businessType,
  sellarDistributionSetupEnabled,
}: {
  enabled?: boolean;
  supplierId: number | undefined;
  businessType: string | undefined;
  sellarDistributionSetupEnabled: boolean;
}) => {
  return (
    enabled &&
    !!supplierId &&
    (businessType !== "supplier" || sellarDistributionSetupEnabled)
  );
};
